import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Sidebar from './Sidebar';
import Navbar from './Navbar';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const JuneDoctorsList = () => {
    const [doctorList, setDoctorList] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedIds, setSelectedIds] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState("");
    const [selectedYear, setSelectedYear] = useState("");
    const recordsPerPage = 10;

    useEffect(() => {
    const token = localStorage.getItem("jwt_token");

    const fetchDoctorsList = async () => {
        try {
            let url = `${API_BASE_URL}api/getJuneTarget`;

            // Add query parameters if selected
            const params = new URLSearchParams();
            if (selectedMonth) params.append("month", selectedMonth);
            if (selectedYear) params.append("year", selectedYear);
            if (params.toString()) url += `?${params.toString()}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
           if (Array.isArray(data.data)) {
    setDoctorList(data.data);
    setFilteredData(data.data);

    const alreadyInvoiced = data.data
        .filter(doc => doc.inv_status === 'Y')
        .map(doc => doc.emp_code);
    setSelectedIds(alreadyInvoiced);
} else {
    console.error('Data is not an array:', data);
    setDoctorList([]);
    setFilteredData([]);
    setSelectedIds([]); // also clear selected checkboxes
}
        } catch (error) {
            console.error('Error:', error);
        }
    };

    fetchDoctorsList();
}, [selectedMonth, selectedYear]);


    // Search Functionality
    useEffect(() => {
        if (searchQuery.trim() === "") {
            setFilteredData(doctorList);
        } else {
            const filtered = doctorList.filter(item =>
                item.comp_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.emp_code?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.mobile?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.pay_model?.toLowerCase().includes(searchQuery.toLowerCase())
            );
            setFilteredData(filtered);
        }
        setCurrentPage(1);
    }, [searchQuery, doctorList]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredData.length / recordsPerPage);
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);

    const goToPage = (pageNumber) => setCurrentPage(pageNumber);

    const handleCheckboxChange = async (isChecked, empCode) => {
        const token = localStorage.getItem("jwt_token");

        // If limit exceeded
        if (isChecked && selectedIds.length >= 5) {
            alert("You can select a maximum of 5 doctors.");
            return;
        }

        try {
            const response = await fetch(`${API_BASE_URL}api/updateInvoiceStatus`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({
                    emp_code: empCode,
                    inv_status: isChecked ? 'Y' : 'N'  // ✅ Send correct value
                })
            });

            const data = await response.json();
            if (!data.STATUS) {
                alert("Failed to update invoice status.");
                return;
            }

            // Update state only if API is successful
            setSelectedIds(prev =>
                isChecked
                    ? [...prev, empCode]
                    : prev.filter(id => id !== empCode)
            );
        } catch (error) {
            console.error("API error:", error);
        }
    };


    const handleSelectAll = (isChecked) => {
        if (isChecked) {
            const idsToSelect = currentRecords
                .map(row => row.emp_code)
                .filter(id => !selectedIds.includes(id)); // Only new ones

            const availableSlots = 5 - selectedIds.length;

            if (availableSlots <= 0) {
                alert("You can select a maximum of 5 doctors.");
                return;
            }

            const limitedSelection = idsToSelect.slice(0, availableSlots);

            setSelectedIds(prev => [...prev, ...limitedSelection]);
        } else {
            const idsToUnselect = currentRecords.map(row => row.emp_code);
            setSelectedIds(prev => prev.filter(id => !idsToUnselect.includes(id)));
        }
    };

    return (
        <div className="wrapper">
            <Sidebar />
            <main className="main-content content-page">
                <div className="position-relative">
                    <Navbar />
                </div>
                <div className="content-inner container-fluid pb-0" id="page_layout">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header-custom d-flex justify-content-between p-4 mb-0 row">
                                    <div className="header-title col-4">
                                        <h4 className="card-title">Doctors List</h4>
                                    </div>
                                    <div className="header-action col-8">
                                        <div className="row">
                                            {/* Search Input */}
                                            <div className="col-md-4">
                                                <div className="form-group mb-0">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        placeholder="Search by Name, BMID, Email, Role, or Mobile"
                                                        value={searchQuery}
                                                        onChange={(e) => setSearchQuery(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            {/* Month Dropdown */}
                                            <div className="col-md-4">
                                                <select
                                                    className="form-control form-control-sm"
                                                    value={selectedMonth}
                                                    onChange={(e) => setSelectedMonth(e.target.value)}
                                                >
                                                    <option value="">All Months</option>
                                                    <option value="01">Jan</option>
                                                    <option value="02">Feb</option>
                                                    <option value="03">Mar</option>
                                                    <option value="04">Apr</option>
                                                    <option value="05">May</option>
                                                    <option value="06">Jun</option>
                                                    <option value="07">Jul</option>
                                                    <option value="08">Aug</option>
                                                    <option value="09">Sep</option>
                                                    <option value="10">Oct</option>
                                                    <option value="11">Nov</option>
                                                    <option value="12">Dec</option>
                                                </select>
                                            </div>

                                            {/* Year Dropdown */}
                                            <div className="col-md-4">
                                                <select
                                                    className="form-control form-control-sm"
                                                    value={selectedYear}
                                                    onChange={(e) => setSelectedYear(e.target.value)}
                                                >
                                                    <option value="">All Years</option>
                                                    {[...Array(9)].map((_, i) => {
                                                        const year = 2022 + i;
                                                        return (
                                                            <option key={year} value={year}>{year}</option>
                                                        );
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Table */}
                        <div className="col-12 table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col">
                                            <input
                                                type="checkbox"
                                                onChange={(e) => handleSelectAll(e.target.checked)}
                                                checked={currentRecords.every(row => selectedIds.includes(row.emp_code))}
                                            /></th>
                                        <th scope="col">sl .no</th>
                                        <th scope="col">Name</th>
                                        <th scope="col">BMID</th>
                                        <th scope="col">DOJ</th>
                                        <th scope="col">Mobile</th>
                                        <th scope="col">Email</th>
                                        <th scope="col">Type</th>
                                        <th scope="col">Status</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {currentRecords.length > 0 ? (
                                        currentRecords.map((doctor, index) => (
                                            <tr key={doctor.doc_id}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedIds.includes(doctor.emp_code)}
                                                        onChange={(e) => handleCheckboxChange(e.target.checked, doctor.emp_code)}
                                                    />
                                                </td>
                                                <th scope="row">{indexOfFirstRecord + index + 1}</th>
                                                <td>{doctor.comp_name}</td>
                                                <td>{doctor.emp_code}</td>
                                                <td>{doctor.doj}</td>
                                                <td>{doctor.mobile}</td>
                                                <td>{doctor.email}</td>
                                                <td>{doctor.pay_model}</td>
                                                <td>{doctor.Active}</td>

                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="9" className="text-center">No records found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination */}
                        <div className="d-flex justify-content-center align-items-center mt-3">
                            <nav>
                                <ul className="pagination">
                                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                        <button className="page-link" onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1}>
                                            «
                                        </button>
                                    </li>

                                    {totalPages > 5 && currentPage > 3 && (
                                        <li className="page-item">
                                            <button className="page-link" onClick={() => goToPage(1)}>1</button>
                                        </li>
                                    )}
                                    {totalPages > 5 && currentPage > 4 && <li className="page-item disabled"><span className="page-link">...</span></li>}

                                    {Array.from({ length: totalPages }, (_, index) => index + 1)
                                        .filter(pageNumber =>
                                            pageNumber === 1 ||
                                            pageNumber === totalPages ||
                                            (pageNumber >= currentPage - 2 && pageNumber <= currentPage + 2)
                                        )
                                        .map(pageNumber => (
                                            <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? "active" : ""}`}>
                                                <button className="page-link" onClick={() => goToPage(pageNumber)}>{pageNumber}</button>
                                            </li>
                                        ))
                                    }

                                    {totalPages > 5 && currentPage < totalPages - 3 && <li className="page-item disabled"><span className="page-link">...</span></li>}
                                    {totalPages > 5 && currentPage < totalPages - 2 && <li className="page-item"><button className="page-link" onClick={() => goToPage(totalPages)}>{totalPages}</button></li>}

                                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                                        <button className="page-link" onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages}>
                                            »
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default JuneDoctorsList;
